import React, { useEffect, useState } from 'react'
import { getStatus } from '../../helperFunction/status';
import { Link } from 'react-router-dom';
function ClaimRow({ status, data, apiCallHandler1, apiCallHandler }) {
    const [curruntStatus, setCurruntStatus] = useState();
    useEffect(() => {
        if (data) {
            const taskData = {
                ...data.task,
                isClaimed: data.isClaimed,
                outerStatus: data.status,
            };
            const status = getStatus(taskData, 'taskParticipated');
            setCurruntStatus(status);
            // console.log(status, 'yyyyyyyyyy');
        }
    }, [data]);
    const handleClaim = () => {
        if (data?.task?.disputeWinnerId) {
            apiCallHandler1(data);
        } else {
            apiCallHandler(data);
        }
    };
  return (
      <td>
          {curruntStatus?.status === 'Winner Determined' ? (
              <button className="actionbtn w-100" onClick={handleClaim}>
                  Withdraw
              </button>
          ) : curruntStatus?.status === 'live' && data?.status !== 'submitted' ? (
              <Link to={`/similartaskdetail/${data?.task?.id}`} className="blueborderbtn w-100 text-decoration-none" >
                  Submit Task
              </Link>
              ) : curruntStatus?.status === 'inDisputePeriod' && data?.status !== 'winner' && data?.status !== 'disputed' ? (
                      <Link to={`/similartaskdetail/${data?.task?.id}`} className="disputedbtn w-100 text-decoration-none" >
                  Create Dispute
              </Link>
          ) : null}
      </td>
  )
}

export default ClaimRow
